import AgencyToggleButton from 'components/AgencyToggleButton/AgencyToggleButton';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useAgencies } from 'hooks/useAgencies';
import Label from 'components/Label/Label';
import './agency-chooser.scss';

export default function AgencyChooser({
  showLabel = false,
  currentAgencyId,
  onSelected = () => {},
}) {
  const { agencies, loadingAgencies } = useAgencies();

  return (
    <>
      <Dimmer active={loadingAgencies} inverted>
        <Loader>Cargando agencias…</Loader>
      </Dimmer>
      <div>
        {showLabel && <Label small>Agencia</Label>}
        <div className="agency-chooser" role="listbox">
          {agencies.map((agency) => (
            <AgencyToggleButton
              key={agency?.id}
              agency={agency}
              active={parseInt(currentAgencyId) === agency?.id}
              onToggle={() => onSelected(agency)}
            />
          ))}
        </div>
      </div>
    </>
  );
}
